<div class="flex flex-col gap-6">
  <desy-collapsible>
    <span class="text-xl font-bold">Sistemas de IA</span>

    <desy-content>
      <div class="flex flex-col flex-1 gap-4">
        @for (card of project?.cards || []; track card.id) {
          <app-system-card
            [systemName]="card.systemName || '-'"
            [state]="card.state || '-'"
            [buttons]="card.buttons || []"
            [creationUser]="card.creationUser || '-'"
            [creationDate]="card.date"
            [infoCard]="card.infoCard"
            [description]="card.description || '-'" />
        }
      </div>
    </desy-content>
  </desy-collapsible>
</div>
